export const UNKNOWN_BARCODE_NON_COMPLIANCE_BLADE_ID = "inbounds.nonComplianceUnknownBarcodeBlade";
export const MISSING_BARCODE_NON_COMPLIANCE_BLADE_ID = "inbounds.nonComplianceMissingBarcodeBlade";
export const UNEXPECTED_BARCODE_NON_COMPLIANCE_BLADE_ID = "inbounds.nonComplianceUnexpectedBarcodeBlade";
export const DAMAGED_PRODUCT_NON_COMPLIANCE_BLADE_ID = "inbounds.nonComplianceDamagedProductBlade";
export const UNEXPECTED_SKU_NON_COMPLIANCE_BLADE_ID = "inbounds.nonComplianceUnexpectedSkuBlade";
export const MISMATCH_CASE_QTY_NON_COMPLIANCE_BLADE_ID = "inbounds.nonComplianceMismatchCaseQtyBlade";
export const GENERIC_ISSUE_BLADE_ID = "inbounds.nonComplianceGenericIssueBlade";
